import { generatePath } from 'react-router-dom'
import { Params } from 'react-router'

export const router = <S extends string>(path: S, params?: Params<S>) => {
  return generatePath(path, params as any)
}

export const routesPath = {
  home: '/',
  onboarding: '/login',
  resetPassword: '/reset-password',
  initPassword: '/create-password',
  forgotPassword: '/forgot-password',
  account: '/mon-compte',
  declaration: '/declaration',
  userDeclarations: '/mes-declarations',
  authCallback: '/auth/callback',
  faq: '/faq',
  page: '/:slug',
}
